import { getPerformanceNavigationTiming } from '../internal/util';
export class EffectiveOpenPageExtension {
    async preRegister(option) {
        option.slardar.on('beforeSend', (e) => {
            if (e.ev_type === 'performance' && e.payload.isCustom === true) {
                if (e.payload.name === 'container_init_cost') {
                    this._containerInitTime = e.payload.value;
                }
                else if (e.payload.name === 'render_start') {
                    this._renderStartTime = e.payload.value;
                }
                else if (e.payload.name === 'render_end') {
                    this._renderEndTime = e.payload.value;
                }
                else if (e.payload.name === 'actual_fmp') {
                    this._actualFMPDuration = e.payload.value;
                    this._sendEvent(option.slardar);
                }
            }
            if (e.ev_type === 'custom' && e.payload.type === 'event') {
                if (e.payload.name === 'ttapplugin_info') {
                    this._appParseStartTime = e.payload.metrics.appParseStart;
                    this._vmokReadyToLoadTime = e.payload.metrics.vmokReadyToLoad;
                    this._vmokLoadedTime = e.payload.metrics.vmokLoaded;
                }
                else if (e.payload.name === 'ttapplugin_first_screen_request') {
                    this._requestStartTime = e.payload.metrics.requestStart;
                    this._requestEndTime = e.payload.metrics.requestEnd;
                }
                else if (e.payload.name === 'ttapplugin_inapp_info') {
                    this._containerInitTotalTime = e.payload.metrics.containerInitTotalTime;
                }
            }
            return e;
        });
        return;
    }
    async postRegister(_option) {
        return;
    }
    _sendEvent(client) {
        const ttfb = this._getTTFB();
        const metrics = {
            count: 1,
            ttfb,
            container_init_cost: this._containerInitTime,
            container_init_total_time: this._containerInitTotalTime,
            app_parse_start: this._appParseStartTime,
            vmok_ready_to_load: this._vmokReadyToLoadTime,
            vmok_loaded: this._vmokLoadedTime,
            render_start: this._renderStartTime,
            render_end: this._renderEndTime,
            request_start: this._requestStartTime,
            request_end: this._requestEndTime,
            ...this._getResourceSize(),
        };
        void Promise.resolve().then(() => client.callClient('sendEvent', {
            // 为了统计 slardar 的跳出率，性能指标的采样率会变，所以这里统一使用自定义事件
            name: EffectiveOpenPageExtension._EVENT_NAME,
            metrics: Object.fromEntries(Object.entries(metrics).filter(([, value]) => {
                return value !== undefined;
            })),
        }));
    }
    _getTTFB() {
        const timing = getPerformanceNavigationTiming();
        if (!timing) {
            return undefined;
        }
        return timing.responseEnd - timing.startTime;
    }
    _getResourceSize() {
        var _a;
        if (this._actualFMPDuration === undefined) {
            return {};
        }
        const actualFMP = this._actualFMPDuration;
        const resourceSize = {
            total_size: 0,
            total_transfer_size: 0,
        };
        const resources = window.performance.getEntriesByType('resource');
        const navigation = window.performance.getEntriesByType('navigation');
        if ((_a = navigation[0]) === null || _a === void 0 ? void 0 : _a.decodedBodySize) {
            resourceSize.total_size += navigation[0].decodedBodySize;
            resourceSize.total_transfer_size += navigation[0].transferSize;
            resourceSize.html_size = navigation[0].decodedBodySize;
        }
        resources.forEach((resource) => {
            var _a;
            if (resource.responseEnd > actualFMP) {
                return;
            }
            const filename = getFileName(resource.name);
            if (filename === null) {
                return;
            }
            resourceSize.total_size += resource.encodedBodySize;
            resourceSize.total_transfer_size += resource.transferSize;
            const type = detectFileType(filename);
            const key = `${type}_size`;
            // eslint-disable-next-line @ttfe/@typescript-eslint/no-unnecessary-condition
            resourceSize[key] = ((_a = resourceSize[key]) !== null && _a !== void 0 ? _a : 0) + resource.encodedBodySize;
        });
        return resourceSize;
    }
}
EffectiveOpenPageExtension._EVENT_NAME = 'ttapplugin_effective_open_page';
export var AssetTypeEnum;
(function (AssetTypeEnum) {
    AssetTypeEnum["Js"] = "js";
    AssetTypeEnum["Css"] = "css";
    AssetTypeEnum["Image"] = "image";
    AssetTypeEnum["Font"] = "font";
    AssetTypeEnum["Html"] = "html";
    AssetTypeEnum["Media"] = "media";
    AssetTypeEnum["Other"] = "other";
})(AssetTypeEnum || (AssetTypeEnum = {}));
const regexps = {
    [AssetTypeEnum.Js]: /\.m?js$/i,
    [AssetTypeEnum.Css]: /\.css$/i,
    [AssetTypeEnum.Html]: /\.html?$/i,
    [AssetTypeEnum.Image]: /\.(jpe?g|png|svg|gif|webp|heif|bmp)$/i,
    [AssetTypeEnum.Font]: /\.(otf|ttf|eot|woff2?)$/i,
    [AssetTypeEnum.Media]: /\.(mp4|webm|mkv|flv|avi|wmv)$/i,
};
function getFileName(url) {
    // 这段正则包含捕获组，用于获取文件名
    const regex = /\/([^\/?#]+\.[^\/?#.]+)(?:\?.*)?$/;
    const matches = url.match(regex);
    // 如果匹配成功，返回捕获的文件名
    return matches ? matches[1] : null;
}
export function detectFileType(name) {
    for (const [type, regexp] of Object.entries(regexps)) {
        if (regexp.test(name)) {
            return type;
        }
    }
    return AssetTypeEnum.Other;
}
//# sourceMappingURL=effectiveOpenPage.js.map